import Vue from 'vue'
import Vuex from 'vuex'

export default class {
    constructor() {
        Vue.use(Vuex);
        const state = {
	        loading: true,
			    config: null,
	        locations: null,
		    };
        const getters = {
			    config: state => state.config,
			    loading: state => state.loading,
	        apiKey: state => state.config.apiKey,
          distanceOptions: state => state.config.distanceOptions,
	        locations: state => state.locations,
	        options: state => state.config.mapOptions,
	        icons: state => state.config.icons,
          locationPlaceholder: state => state.config.locationPlaceholder,
          drivingErrorMessage: state => state.config.drivingErrorMessage
		    };
        const mutations = {
			    setStateValue(state, payload) {
				    state[payload.key] = payload.value;
		      },
		    };
        const actions = {
          async loadConfig({commit}, payload) {
				  await fetch(payload)
            .then(res => res.json())
            .then(data => {
              commit("setStateValue", { key: 'config', value: data })
              commit("setStateValue", { key: 'loading', value: false })
            })
            .catch(err => {
              console.error(err)
            })
			    },
	        loadLocations({commit}, payload) {
		        return fetch(payload)
			        .then(res => res.json())
			        .then(data => {
				        commit("setStateValue", { key: 'locations', value: data })
			        })
			        .catch(err => {
				        console.error(err)
			        })
	        },
		    };

        this.store = new Vuex.Store({
            state,
            getters,
            mutations,
            actions
        });
    }
}
